// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout-module--main--3hlYJ","centered":"Layout-module--centered--1Gq4Q"};